// extracted by mini-css-extract-plugin
module.exports = {"botonFav":"style_botonFav__1Im9W","isFav":"style_isFav__3hKos"};